import React from "react";
import Main from "./Main";
import ProductCategory from "./ProductCategory";
import HomeProducts from "./HomeProducts";
import Testimonials from "./Testimonials";
import Newsletter from "./Newsletter";

const Home = () => {
  return (
    <div>
      
      <Main />
      <HomeProducts />
      <ProductCategory />
      <Testimonials />
      <Newsletter />
      
    </div>
  );
};

export default Home;
